import { React, useState, useEffect } from "react";

const PopUpRace17Results = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let raceCards = [];
    let race17Markets = [];
    let race17Winners = [];

    if (marketType == 28) {

        raceCards = [
            resultData.c1,
            resultData.c2,
            resultData.c3,
            resultData.c4,
        ].filter(Boolean);

        race17Markets = [
            resultData.cat_rnr1,
            resultData.cat_rnr3,
        ].filter(Boolean);

        race17Winners = resultData.resultTxt
            ? resultData.resultTxt
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean)
            : [];
    }


    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="race17" style={{ display: marketType == 28 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">

                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>Race To 17</span>
                                        </b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "flex-start",
                                                        padding: "5px"
                                                    }}
                                                >
                                                    {raceCards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {race17Markets.map((market, index) => {
                                            const winner = race17Winners.includes(market);
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px"
                                                    }}
                                                >
                                                    <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                                        {market}
                                                    </div>
                                                    <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: "#000", textTransform: "uppercase" }}>
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpRace17Results;

